import { Modal } from 'react-bootstrap';

function Popup(props) {
    return (
        <Modal show={true} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{props.body}</Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger" onClick={props.onAction}>
                    {props.action}
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default Popup;